import { Tabs, useMantineColorScheme } from "@mantine/core";

import { routings } from "@/api/routing/useRoutingQuery";
import { InspectSpecificationUpdateForm } from "@/features/inspect/components/inspectSpecification/form/InspectSpecificationUpdateForm";
import { RoutingBomRow } from "@/features/item/components/form/itemsStepperForm/routingsBomList/RoutingBomRow";
import { RoutingBomInform } from "@/features/routing/components/inform/RoutingBomInform";
import { RoutingInform } from "@/features/routing/components/inform/RoutingInform";
import { Main } from "@/features/standard/Main";
import { DetailContainer } from "@/features/standard/detail/Container";
import { DetailContent } from "@/features/standard/detail/Content";
import { LeftSpace } from "@/features/standard/detail/LeftSpace";
import { RightSpace } from "@/features/standard/detail/RightSpace";
import { DetailWrapper } from "@/features/standard/detail/Wrapper";
import { AuthSignupPost201ResponseEquipmentWorksInnerRoutingDataRoutingBomsInner } from "@sizlcorp/sizl-api-document/dist/models";
import { useQuery } from "@tanstack/react-query";
import { RoutingDetailActionHeader } from "../header/RoutingDetailActionHeader";

const Detail = Object.assign(Main, {
  Container: DetailContainer,
  Wrapper: DetailWrapper,
  Content: DetailContent,
});

interface RoutingDetailFormProps {
  routingCode: string | undefined;
}
export const RoutingDetailForm = ({ routingCode }: RoutingDetailFormProps) => {
  const { colorScheme } = useMantineColorScheme();
  const { data: routing } = useQuery(
    routings.get({
      query: {
        $and: [{ code: { $eq: routingCode } }],
      },
      populate: ["routingBoms"],
    }),
  );

  const routingData = routing?.data?.rows && routing?.data?.rows[0];

  return (
    <>
      <Detail.Container>
        <RoutingDetailActionHeader data={routingData} />
        <Detail.Wrapper>
          <Detail.Content>
            <RoutingInform data={routingData} />
            <Tabs
              variant="outline"
              defaultValue="bom"
              styles={(theme) => ({
                tab: {
                  "&:not([data-active])": {
                    backgroundColor:
                      colorScheme === "dark" ? "var(--gray-9, #1e1e1e)" : theme.colors?.gray?.[0],
                  },
                },
              })}
            >
              <Tabs.List>
                <LeftSpace />
                <Tabs.Tab value="bom">BOM</Tabs.Tab>
                <Tabs.Tab value="inspectSpecification">검사표준</Tabs.Tab>
                <RightSpace />
              </Tabs.List>
              <Tabs.Panel value="bom">
                <RoutingBomInform />
                <RoutingBomRow
                  routingBoms={
                    routingData?.routingBoms as AuthSignupPost201ResponseEquipmentWorksInnerRoutingDataRoutingBomsInner[]
                  }
                />
              </Tabs.Panel>
              <Tabs.Panel value="inspectSpecification">
                <InspectSpecificationUpdateForm data={routingData} />
              </Tabs.Panel>
            </Tabs>
          </Detail.Content>
        </Detail.Wrapper>
      </Detail.Container>
    </>
  );
};
